import {LitElement, html, css, nothing} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import tippy from 'tippy.js';
import Decimal from './break_infinity';
import global_css from './global-css';
import {IFilterable} from './interfaces/filterable';
import {ToolTippy} from './mixins/tooltippy';
import {UnlockableLitElement} from './unlockable';

// TODO Add percent completeness as a visible progression (div with % completed as width)

@customElement('ri-unlockables-entry')
export class UnlockablesEntry
  extends ToolTippy(LitElement, {interactive: false})
  implements IFilterable
{
  name = 'Unlockable';
  displayName = 'Unlockable';
  tags: Set<string> = new Set();
  @property({attribute: false}) filterable: UnlockableLitElement | undefined;
  static override styles = [
    global_css,
    css`
      :host {
        /* border: 1px rgb(var(--black, black)) solid; */
        --value-color: 180, 180, 180;
        --none-color: 20, 20, 20;
      }

      div {
        transition: 1s linear all;
        border: 1px rgb(var(--value-color, black)) solid;
        border-radius: 10px;
        /* background: inherit; */
      }

      .label {
        padding: 2px;
        /* mix-blend-mode: difference; */
        color: rgb(var(--none-color));
        font-weight: bold;
      }

      div.entry-locked {
        background: #fff8;
        border-color: rgb(var(--black, black));
        border-width: 2px;
      }
    `,
  ];
  unlocked?: boolean | undefined;

  constructor() {
    super();
    this.addEventListener('mouseover', () => {
      this.filterable?.classList.add('unlockables-entry-hovered');
    });
    this.addEventListener('mouseout', () => {
      this.filterable?.classList.remove('unlockables-entry-hovered');
    });
  }

  override render() {
    if (!this.filterable) return nothing;
    const unlockString = !this.filterable.visible
      ? 'Hidden'
      : this.filterable.conditionString;
    // setTimeout(() => this.scrollIntoView());
    return html`<div
      class="${this.filterable.new ? 'new' : ''} ${this.filterable.unlocked
        ? ''
        : 'entry-locked'}"
    >
      <smooth-progress .value=${new Decimal(this.filterable.progress())}>
        <div class="nowrap label">
          ${this.filterable.unlocked
            ? this.filterable.displayName
            : unsafeHTML(unlockString)}
        </div>
      </smooth-progress>
    </div>`;
  }

  override _updateTooltip(): void {
    const unlockString = !this.filterable?.visible
      ? 'Hidden'
      : this.filterable?.conditionString;
    if (this.filterable?.unlocked) {
      this.tooltip.setContent(`Required: ${unlockString}`);
    } else {
      this.tooltip.setContent(
        `Unlocks: ${
          this.filterable?.secret
            ? 'Undiscovered'
            : this.filterable?.displayName
        } `
      );
    }
  }
}
